import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.button`
  background-color: white;
  border: none;
  height: 40px;
  cursor: pointer;
  cursor: pointer;
  padding: 0 24px;
  color: ${colors.black};
  letter-spacing: 0.12rem;
  font-size: ${fontSize.xs};
  text-transform: uppercase;
  border: 1px solid ${colors.black};
  width: ${(props) => props.$width || "auto"};
  transition: background-color 0.3s ease;

  &:hover {
    border: 1px solid ${colors.border};
  }

  /* @media (max-width: 500px) {
    width: auto;
  } */
`;

function SecondaryButton(props) {
  return (
    <Wrapper $width={props.width} onClick={props.onClick}>
      {props.title}
    </Wrapper>
  );
}

export default SecondaryButton;
